import useSWR from 'swr';
import type { JobsBoardResponse, UseJobOpeningsResult } from '../utils/types';
import { getDepartmentsFromAshby, getLocationsFromAshby, groupJobsByDepartmentName } from '../utils/helpers';

const JOB_OPENINGS_URL = '/api/job-openings';

async function fetchJobsBoard(url: string): Promise<JobsBoardResponse> {
  const response = await fetch(url);

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    throw new Error(errorData?.error || `Failed to fetch jobs data: ${response.status}`);
  }

  return await response.json();
}

export function useJobOpenings(): UseJobOpeningsResult {
  const { data, error, isValidating } = useSWR<JobsBoardResponse, Error>(JOB_OPENINGS_URL, fetchJobsBoard);
  const isLoading = !data && !error && isValidating;

  if (!data?.jobs || !data?.locations || !data?.departments) {
    return { data: undefined, isLoading, error };
  }

  const departments = getDepartmentsFromAshby(data.departments);

  return {
    data: {
      locations: getLocationsFromAshby(data.locations),
      jobsByDepartmentName: groupJobsByDepartmentName(data.jobs, departments),
      departments: departments,
    },
    isLoading,
    error,
  };
}
